export const FILTER_GENERAL = "Filter.General";
export const FILTER_INTERNAL = "Filter.Internal";
export const FILTER_EXTERNAL = "Filter.External";
export const FILTER_INCOMING = "Filter.Incoming";
export const FILTER_OUTGOING = "Filter.Outgoing";
export const FILTER_UNSIGNED = "Filter.Unsigned";
export const FILTER_ARCHIVED = "Filter.Archived";
export const FILTER_ALL = "Filter.All";

export function docsFilter(type:string) {
  switch (type) {
    case "general": {
      return {
        type: FILTER_GENERAL,
      };
    }
    case "internal": {
      return {
        type: FILTER_INTERNAL,
      };
    }
    case "external": {
      return {
        type: FILTER_EXTERNAL,
      };
    }
    case "incoming": {
      return {
        type: FILTER_INCOMING,
      };
    }
    case "outgoing": {
      return {
        type: FILTER_OUTGOING,
      };
    }
    case "unsigned": {
      return {
        type: FILTER_UNSIGNED,
      };
    }
    case "archived": {
      return {
        type: FILTER_ARCHIVED,
      }
    }
    default: {
      return {
        type: FILTER_ALL,
      };
    }
  }
}

export const PAGE_SET = "Page.Set";

export function setPage() {
  return {
    type: PAGE_SET,
  }
}
